let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iJOFz")).then(() => parcelRequire('1FtPF'));